<template>
	<el-card>
        <div slot="header">
            <span class="top_title">商品入库</span>
        </div>
        <div class="searchItem">
            <div class="search">
                <span style="padding-right:10px">日期:</span>
                <el-date-picker
                    v-model="date"
                    type="datetime"
                    placeholder="日期"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    style="width: 180px;padding-right:10px"
                />
            </div>
            <div class="search">
                <span style="padding-right:10px">入库类型:</span>
                <el-select v-model="oper" style="width:180px">
                    <el-option value="生产入库" label="生产入库"></el-option>
                    <el-option value="其他入库" label="其他入库"></el-option>
                </el-select>
            </div>
            <div style="padding-right:10px">
                <Customer :orderForm="search" :hideStar='true'></Customer>
            </div>
        </div>
		<SPTable ref="spt" :cols='cols' :structure="structure" @returnData="saveEnter"></SPTable>
		<div class="rootbtn">
            <el-button type="primary" @click="getData" :loading="lock">确认</el-button>
		</div>
        
	</el-card>
</template>

<script>
import Customer from  "../../components/customer";
import SPTable from  "../../components/table-column/supertable";
	export default {
		components: {SPTable,Customer},
		data() {
			return {
				cols: [
					{
						prop: "name",
						label: "商品",
						edit:'productEdit',
						type: "productEdit",
						width: 240,
                    },
                    {
						prop: "spec",
						label: "规格",
						edit:'',
						type: "",
						width: 130,
                    },
                    {
						prop: "store",
						label: "仓库",
						edit:'whEdit',
						type: "whEdit",
                        width: 130,
                        showName:'storename',
                        main:1,
					},
                    {
						prop: "stock",
						label: "库存",
						edit:'',
						type: "stockEdit",
						width: 130,
                    },
					{
						prop: "count",
						label: "数量("+this.$global.pack+")",
						edit:'countEdit',
						type: "countEdit",
                        width: 130,
                        unit:this.$global.pack,
                        hide:this.$global.buyType==2?true:false,
                    },
					{
						prop: "num",
						label: "数量("+this.$global.unit+")",
						edit:'numEdit',
						type: "countEdit",
                        width: 130,
                        unit:this.$global.unit,
                        hide:this.$global.buyType==1?true:false,
                    },
                    {
						prop: "price",
						label: "价格(元)",
						edit:'',
						type: "",
                        width: 130,
                    },
                    {
						prop: "unit",
						label: "单位",
						edit:'',
						type: "unitEdit",
						width: 130,
                    },
					{
						prop: "remark",
						label: "备注",
						edit:'remarkEdit',
						type: "remarkEdit",
						min_width: 200,
						align: "center",
					},
				],
                date: this.$common.format(new Date()),
                oper:"生产入库",
                search:{
                    cid:'',
                    cname:'',
                },
                lock:false,
			}
		},
		methods: {
            structure(){
                let obj = {
                    id:0,
                    pid: '',
                    spid:'',
					spec:'',
					price: 0,
					unit: 0,
                    store: '',
                    enterstore:'',
                    storename:'',
                    stock: '',
                    stockDesc: '',
                    negative:'',
                    count: 0,
                    name:'',
                    number:'',
                    num:0,
                    remark:'',
                    stockList:{},
                    productEdit:false,
                    whEdit:false,
                    countEdit:false,
                    numEdit:false,
                    remarkEdit:false,
                }
                return obj;
            },
            getData(){
                this.lock = true;
                this.$refs.spt.getData();
            },
			saveEnter(formData) {
                let obj = {
                    date:this.date,
                    oper:this.oper,
                }
                if(this.search.cid>0){
                    obj.cid = this.search.cid;
                }
                let detail = [];
                formData.forEach(e=>{
                    if(e.count>0||e.num>0){
                        let obj1 = {
                            pid:e.pid,
                            spid:e.spid,
                            pro:e.number+"_"+e.name,
                            wid:e.store,
                            // wname
                            // stock
                            price:e.price,
                            spec:e.spec,
                            // packunit:e.unit+"双/件",
                            // packword
                            pack:e.count,
                            unit:e.unit,
                            small:e.num,
                            remark:e.remark,
                            amount:e.count*e.unit+e.num,
                        }
                        detail.push(obj1);
                    }
                })
                if(detail.length>0){
                    obj.detail = JSON.stringify(detail);
                    this.$api.addInboundRecord(obj).then(res=>{
                        if(res.data.code==1){
                            this.$notify({
                                title: "商品入库",
                                message: "入库成功",
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.$router.push("/storeDetail");
                                },
                            })
                        }else{
                            this.$common.error(res.data.msg);
                        }
                    })
                }else{
                    this.$common.error("没有可入库数据");
                    this.lock = false;
                }
            },
        },
	}
</script>
